import React, { useEffect, useState } from "react";
// import { Tooltip } from "bootstrap";
import "./TableContainer.css";

function TruncatedText({ text, maxLength }) {
  const [isHovered, setIsHovered] = useState(false);
  const isTruncated = text?.length > maxLength;
  const truncatedText = isTruncated ? text?.slice(0, maxLength) + "..." : text;

  return (
    <div
      className="truncated-text-wrapper"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <span className="truncated-text">{truncatedText}</span>
      {isHovered && isTruncated && <div className="tooltip">{text}</div>}
    </div>
  );
}

function TableContainer({
  headerGroups,
  getTableBodyProps,
  rows,
  getTableProps,
  prepareRow,
  getRowProps = () => ({}),
  totalRecords,
  tableData,
  isPatientReportColor = false,
  showPaymentModeFooter = false,
  showColumns = 5,
}) {
  const [showAllColumns, setShowAllColumns] = useState(false);

  const toggleShowColumns = () => {
    setShowAllColumns(!showAllColumns);
  };

  const columnsToTruncate = [
    "template_description",
    "observation",
    "panel_name",
    "franchise_name",
    "patient_name",
    "panel_code",
    "investigation_type",
    "branch_address",
    "message",
    "address",
    "document_name",
    "franchise_code",
    "company_name",
    "remark",
    "lab_department",
    "comments",
    "test_name",
    "state",
    "investigation_details",
    // "investigation_name",
    "package_obj.package_name",
    // "Investigation Name",
  ];

  const headerFullForms = {
    PP: "Purchase Price",
    SP: "Selling Price",
    QIn: "Quantity In",
    QOut: "Quantity Out",
    TC: "Total Cost",
    TQB: "Total Quantity Balance",
  };

  const documentFooterColumns = [
    "Total Amount",
    "Discount Amount",
    "Additional Amount",
    "After Discount Amount",
    "Balance Amount",
    "Doctor IP Amount",
    "Agent IP Amount",
    "Performing Doctor Amount",
    "Net Amount",
    "Gross Amount",
    "Paid Amount",
    "Outstanding Amount",
    "Received Amt",
    "Due Amount",
    "Total MRP Rate",
    "Amt",
  ];

  // useEffect(() => {
  //   const tooltipTriggerList = document.querySelectorAll(
  //     '[data-bs-toggle="tooltip"]',
  //   );
  //   tooltipTriggerList?.forEach((tooltip) => {
  //     new Tooltip(tooltip);
  //   });
  // }, []);

  const hasDocumentColumns = headerGroups.some((headerGroup) =>
    headerGroup.headers.some((column) =>
      documentFooterColumns.includes(column.Header),
    ),
  );

  // Check if table has payment mode columns (columns starting with "payment_mode_")
  const hasPaymentModeColumns = headerGroups.some((headerGroup) =>
    headerGroup.headers.some(
      (column) =>
        column.id?.startsWith("payment_mode_") ||
        column.Header === "Total Amount",
    ),
  );

  return (
    <>
      <div className="boxContent noPadding">
        <div className="contentScroll">
          <table
            {...getTableProps()}
            className={`table mb-0 table-hover ${
              headerGroups.some((headerGroup) =>
                headerGroup.headers.some((column) =>
                  Object.keys(headerFullForms).includes(column.Header),
                ),
              )
                ? "table-bordered"
                : ""
            }`}
            style={
              headerGroups.some((headerGroup) =>
                headerGroup.headers.some((column) =>
                  Object.keys(headerFullForms).includes(column.Header),
                ),
              )
                ? { border: "black" }
                : {}
            }
          >
            <thead>
              {headerGroups.map((headerGroup) => {
                const { key, ...headerGroupProps } =
                  headerGroup.getHeaderGroupProps();
                const isResultEntryObservationHeader =
                  headerGroup.headers[0]?.Header === "Observation Name" &&
                  headerGroup.headers[1]?.Header === "Value" &&
                  headerGroup.headers[2]?.Header === "Flag" &&
                  headerGroup.headers[3]?.Header === "MacReading" &&
                  headerGroup.headers[4]?.Header === "Unit" &&
                  headerGroup.headers[5]?.Header === "MinValue" &&
                  headerGroup.headers[6]?.Header === "MaxValue" &&
                  headerGroup.headers[7]?.Header === "Display Reading" &&
                  headerGroup.headers[8]?.Header === "Method";

                const isSpecialHeader =
                  (headerGroup.headers[2]?.Header === "Employee Name" &&
                    headerGroup.headers[3]?.Header === "Branch") ||
                  (headerGroup.headers[2]?.Header ===
                    "Investigation/Test Name" &&
                    headerGroup.headers[3]?.Header ===
                      "Investigation/Test Code") ||
                  (headerGroup.headers[2]?.Header ===
                    "Investigation/Test Name" &&
                    headerGroup.headers[3]?.Header === "Reporting") ||
                  (headerGroup.headers[2]?.Header === "Doctor Name" &&
                    headerGroup.headers[3]?.Header === "Degree") ||
                  (headerGroup.headers[2]?.Header === "Patient Name" &&
                    headerGroup.headers[6]?.Header === "Gender") ||
                  (headerGroup.headers[2]?.Header === "Zone Name" &&
                    headerGroup.headers[3]?.Header === "Mobile Number") ||
                  (headerGroup.headers[2]?.Header === "Role Name" &&
                    headerGroup.headers[3]?.Header === "Description") ||
                  (headerGroup.headers[2]?.Header === "Department" &&
                    headerGroup.headers[3]?.Header === "Department Code") ||
                  (headerGroup.headers[1]?.Header === "Agent Name" &&
                    headerGroup.headers[5]?.Header === "Joining Date") ||
                  (headerGroup.headers[1]?.Header === "Appointment Id" &&
                    headerGroup.headers[3]?.Header === "Patient") ||
                  (headerGroup.headers[1]?.Header === "Date" &&
                    headerGroup.headers[5]?.Header === "Age & Gender") ||
                  (headerGroup.headers[1]?.Header === "Date" &&
                    headerGroup.headers[6]?.Header === "Refer Doctor");

                const filteredHeaders = headerGroup.headers.filter(
                  (column, index) => {
                    if (isResultEntryObservationHeader) {
                      return true;
                    }
                    if (
                      showAllColumns ||
                      (isSpecialHeader && index < showColumns)
                    ) {
                      return true;
                    } else if (!isSpecialHeader) {
                      return true;
                    }
                    return false;
                  },
                );

                return (
                  <tr key={key} {...headerGroupProps}>
                    {filteredHeaders.map((column, idx) => {
                      const { key, ...cellProps } = column.getHeaderProps(
                        column.getSortByToggleProps(),
                      );
                      const isLabDeptAtIndex3 =
                        idx === 3 && column.id === "lab_department_name";
                      const tooltipText = headerFullForms[column.Header];
                      const isLastColumn = idx === filteredHeaders.length - 1;

                      return (
                        <th
                          key={key}
                          {...cellProps}
                          style={{
                            color: isResultEntryObservationHeader
                              ? "#387C44"
                              : "black",
                            cursor: column.canSort ? "pointer" : "default",
                            userSelect: "none",
                            ...(isLabDeptAtIndex3
                              ? {
                                  width: "220px",
                                  maxWidth: "220px",
                                  whiteSpace: "normal",
                                  overflowWrap: "anywhere",
                                  wordBreak: "break-word",
                                }
                              : {}),
                          }}
                        >
                          {tooltipText ? (
                            <span
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              title={tooltipText}
                            >
                              {column.render("Header")}
                              {column.canSort && (
                                <span style={{ marginLeft: "5px" }}>
                                  {column.isSorted
                                    ? column.isSortedDesc
                                      ? " 🔽"
                                      : " 🔼"
                                    : " ⇅"}
                                </span>
                              )}
                            </span>
                          ) : (
                            <>
                              {column.render("Header")}
                              {column.canSort && (
                                <span style={{ marginLeft: "5px" }}>
                                  {column.isSorted
                                    ? column.isSortedDesc
                                      ? " 🔽"
                                      : " 🔼"
                                    : " ⇅"}
                                </span>
                              )}
                            </>
                          )}

                          {isLastColumn &&
                            isSpecialHeader &&
                            showAllColumns && (
                              <button
                                className="btn btn-primary w-100"
                                onClick={toggleShowColumns}
                              >
                                Hide
                              </button>
                            )}
                        </th>
                      );
                    })}

                    {isSpecialHeader && !showAllColumns && (
                      <th>
                        <button
                          className="btn btn-primary"
                          onClick={toggleShowColumns}
                        >
                          View All
                        </button>
                      </th>
                    )}
                  </tr>
                );
              })}
            </thead>
            <tbody {...getTableBodyProps()}>
              {rows.map((row, rowIndex) => {
                prepareRow(row);
                const rowProps = getRowProps(row.original) || {};
                const { key, ...restRowProps } = row.getRowProps();

                let rowBackgroundColor = rowProps?.style?.backgroundColor || "";

                if (!rowBackgroundColor) {
                  if (row.original.cancellation_id) {
                    rowBackgroundColor = "#ffcccc";
                  } else if (row.original.balance_amount > 0) {
                    rowBackgroundColor = "#fff9c4";
                  } else if (isPatientReportColor) {
                    rowBackgroundColor =
                      rowIndex % 2 === 0 ? "#f5c9d0" : "#ffffff";
                  } else {
                    rowBackgroundColor =
                      (row.original.inventory_type || "").replace("-", "_") ===
                      "STOCK_IN"
                        ? "#ededed"
                        : (row.original.inventory_type || "").replace(
                              "-",
                              "_",
                            ) === "STOCK_OUT"
                          ? "#f3e1f5"
                          : "";
                  }
                }

                return (
                  <tr
                    key={key}
                    {...restRowProps}
                    onClick={() => {
                      if (typeof rowProps.onClick === "function") {
                        rowProps.onClick();
                      }
                    }}
                  >
                    {row.cells
                      .filter((rowCell, index) => {
                        const isSpecialHeader =
                          (headerGroups[0]?.headers[2]?.Header ===
                            "Employee Name" &&
                            headerGroups[0]?.headers[3]?.Header === "Branch") ||
                          headerGroups[0]?.headers[2]?.Header ===
                            "Investigation/Test Name" ||
                          headerGroups[0]?.headers[2]?.Header === "Role Name" ||
                          headerGroups[0]?.headers[2]?.Header ===
                            "Doctor Name" ||
                          headerGroups[0]?.headers[2]?.Header ===
                            "Patient Name" ||
                          (headerGroups[0]?.headers[2]?.Header ===
                            "Zone Name" &&
                            headerGroups[0]?.headers[3]?.Header ===
                              "Mobile Number") ||
                          (headerGroups[0]?.headers[2]?.Header ===
                            "Department" &&
                            headerGroups[0]?.headers[3]?.Header ===
                              "Department Code") ||
                          (headerGroups[0].headers[1]?.Header ===
                            "Agent Name" &&
                            headerGroups[0].headers[5]?.Header ===
                              "Joining Date") ||
                          (headerGroups[0].headers[1]?.Header ===
                            "Appointment Id" &&
                            headerGroups[0].headers[3]?.Header === "Patient") ||
                          (headerGroups[0].headers[1]?.Header === "Date" &&
                            headerGroups[0].headers[5]?.Header ===
                              "Age & Gender") ||
                          (headerGroups[0].headers[1]?.Header === "Date" &&
                            headerGroups[0].headers[6]?.Header ===
                              "Refer Doctor");
                        if (
                          showAllColumns ||
                          (isSpecialHeader && index < showColumns) ||
                          rowCell?.column.id === "ids"
                        ) {
                          return true;
                        } else if (!isSpecialHeader) {
                          return true;
                        }
                        return false;
                      })
                      .map((rowCell, cellIdx) => {
                        const { key, ...cellProps } = rowCell.getCellProps();
                        const isLabDeptAtIndex3 =
                          cellIdx === 3 &&
                          rowCell.column.id === "lab_department_name";
                        return (
                          <td
                            key={key}
                            {...cellProps}
                            style={{
                              backgroundColor: rowBackgroundColor,
                              ...(isLabDeptAtIndex3
                                ? {
                                    width: "220px",
                                    maxWidth: "220px",
                                    whiteSpace: "normal",
                                    overflowWrap: "anywhere",
                                    wordBreak: "break-word",
                                  }
                                : {}),
                              ...(rowCell.column.id === "investigation_name"
                                ? {
                                    maxWidth: "200px",
                                    whiteSpace: "normal",
                                    overflowWrap: "anywhere",
                                    wordBreak: "break-word",
                                  }
                                : {}),
                            }}
                          >
                            {columnsToTruncate.includes(rowCell.column.id) ? (
                              <TruncatedText
                                text={
                                  rowCell.column.id ===
                                    "investigation_details" &&
                                  Array.isArray(row.original[rowCell.column.id])
                                    ? row.original[rowCell.column.id]
                                        .map((item) => item.investigation_name)
                                        .join(", ")
                                    : rowCell.value || ""
                                }
                                maxLength={23}
                              />
                            ) : (
                              rowCell.render("Cell")
                            )}
                          </td>
                        );
                      })}
                  </tr>
                );
              })}
            </tbody>
            {/* Existing footer for other columns */}
            {tableData?.length > 0 &&
              headerGroups.some((headerGroup) =>
                headerGroup.headers.some((column) =>
                  [
                    "QIn",
                    "QOut",
                    "Profit",
                    "Appointment Amount",
                    "Amount",
                    "Commission",
                    "Commission Debit",
                    "Commission Credit",
                    "Advance Amount",
                    "Net Amt",
                    "Gross Amt",
                    "Dis Amt",
                    "Credit Amount",
                    "Debit Amount",
                    "Received Amount",
                    "Amount After Discount",
                    "Current Balance",
                    "Credit Commission",
                    "Debit Commission",
                    "Commission Amount",
                    "Closing Amount",
                    "Booking Amount",
                    "Opening Amount",
                  ].includes(column.Header),
                ),
              ) && (
                <tfoot>
                  <tr>
                    {headerGroups[0]?.headers.map((column, index) => {
                      if (index === 0) {
                        return (
                          <td
                            key={column.id}
                            style={{ fontWeight: "bold", textAlign: "center" }}
                          >
                            TOTAL
                          </td>
                        );
                      }

                      let totalValue = 0;
                      const totalColumns = [
                        "QIn",
                        "QOut",
                        "Profit",
                        "Appointment Amount",
                        "Amount",
                        "Commission",
                        "Commission Debit",
                        "Commission Credit",
                        "Advance Amount",
                        "Net Amt",
                        "Gross Amt",
                        "Dis Amt",
                        "Credit Amount",
                        "Debit Amount",
                        "Received Amount",
                        "Amount After Discount",
                        "Current Balance",
                        "Credit Commission",
                        "Debit Commission",
                        "Commission Amount",
                        "Closing Amount",
                        "Booking Amount",
                        "Opening Amount",
                      ];

                      if (totalColumns.includes(column.Header)) {
                        totalValue = rows.reduce((sum, row) => {
                          let value;
                          if (typeof column.accessor === "function") {
                            value = column.accessor(row.original);
                          } else {
                            value = row.original[column.id];
                          }
                          return sum + (parseFloat(value) || 0);
                        }, 0);
                      }

                      return (
                        <td key={column.id} style={{ fontWeight: "bold" }}>
                          {totalColumns.includes(column.Header)
                            ? totalValue.toFixed(2)
                            : ""}
                        </td>
                      );
                    })}
                  </tr>
                </tfoot>
              )}
            {tableData?.length > 0 && hasDocumentColumns && (
              <tfoot>
                <tr>
                  <td
                    colSpan={2}
                    style={{ fontWeight: "bold", textAlign: "center" }}
                  >
                    TOTAL
                  </td>

                  {headerGroups[0]?.headers.slice(2).map((column) => {
                    let totalValue = 0;

                    if (documentFooterColumns.includes(column.Header)) {
                      totalValue = rows.reduce((sum, row) => {
                        let value = 0;

                        if (typeof column.Cell === "function") {
                          const cellValue = column.Cell({
                            row,
                            value: row.values[column.id],
                          });
                          value = cellValue;
                        } else if (typeof column.accessor === "function") {
                          value = column.accessor(row.original);
                        } else {
                          value = row.original[column.id];
                        }

                        return sum + (parseFloat(value) || 0);
                      }, 0);
                    } else if (column.Header === "Total") {
                      totalValue = rows.reduce((sum, row) => {
                        const afterDiscount =
                          parseFloat(
                            row.original.total_after_discount_amount,
                          ) || 0;
                        const agentAmount =
                          parseFloat(row.original.total_agent_ip_amount) || 0;
                        const additionalAmount =
                          parseFloat(row.original.total_additional_amount) || 0;
                        const doctorIpAmount =
                          parseFloat(row.original.total_doctor_ip_amount) || 0;
                        const performingDoctorAmount =
                          parseFloat(
                            row.original.total_performing_doctor_amount,
                          ) || 0;

                        const rowTotal =
                          afterDiscount -
                          agentAmount +
                          additionalAmount -
                          doctorIpAmount -
                          performingDoctorAmount;
                        return sum + rowTotal;
                      }, 0);
                    }

                    return (
                      <td key={column.id} style={{ fontWeight: "bold" }}>
                        {documentFooterColumns.includes(column.Header) ||
                        column.Header === "Total"
                          ? totalValue.toFixed(2)
                          : ""}
                      </td>
                    );
                  })}
                </tr>
              </tfoot>
            )}
            {tableData?.length > 0 &&
              showPaymentModeFooter &&
              hasPaymentModeColumns && (
                <tfoot>
                  <tr>
                    <td
                      colSpan={2}
                      style={{ fontWeight: "bold", textAlign: "center" }}
                    >
                      TOTAL
                    </td>

                    {headerGroups[0]?.headers.slice(2).map((column) => {
                      let totalValue = 0;

                      if (
                        column.id?.startsWith("payment_mode_") ||
                        column.Header === "Total Amt"
                      ) {
                        totalValue = rows.reduce((sum, row) => {
                          let value = 0;

                          if (typeof column.Cell === "function") {
                            const cellValue = column.Cell({ row });
                            value = cellValue;
                          } else if (typeof column.accessor === "function") {
                            value = column.accessor(row.original);
                          } else if (column.Header === "Total Amt") {
                            value = row.original.total_amount || 0;
                          } else {
                            value = row.original[column.id] || 0;
                          }
                          return sum + (parseFloat(value) || 0);
                        }, 0);
                      }

                      return (
                        <td key={column.id} style={{ fontWeight: "bold" }}>
                          {column.id?.startsWith("payment_mode_") ||
                          column.Header === "Total Amt"
                            ? totalValue.toFixed(2)
                            : ""}
                        </td>
                      );
                    })}
                  </tr>
                </tfoot>
              )}
          </table>
        </div>
      </div>
      {/* {totalRecords === 0 && <div className="noData">No data found</div>} */}
      {tableData?.length === 0 && <div className="noData">No data found</div>}
    </>
  );
}

export default TableContainer;
